import RequestQuoteForm from "./RequestQuoteForm";

function BookCar() {
  return (
    <section className='book-section'>
      <div className='book-content'>
        <div className='book-content__box'>
          <RequestQuoteForm idPrefix='book' />
        </div>
      </div>
    </section>
  );
}

export default BookCar;
